import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { tap } from 'rxjs';

export const jsonUtilPageSettings: HttpInterceptorFn = (req, next) => {
    // Copy this into a bookmark as its URL. It will open a prompt for you to put the URL.
    // javascript:(function(){var url=prompt("Set URL to intercept?");localStorage.setItem('interceptorUrl', url)})();
    const url = localStorage.getItem('interceptorUrl');

    let newReq: HttpRequest<unknown> | undefined;
    if (isDevMode()) {
        if (req.urlWithParams === url) {
            return next(req).pipe(
                tap(res => {
                    localStorage.removeItem('interceptor');
                    const body = (res as any).body;

                    const iterceptorPageMetadata = {
                        body: body,
                        reqUrlWithParams: req.urlWithParams,
                    };
                    localStorage.setItem('interceptor', JSON.stringify(iterceptorPageMetadata));

                    setTimeout(() => {
                        localStorage.removeItem('interceptor');
                    }, 600000);
                })
            );
        }
        newReq = req;
    } else {
        newReq = req;
    }

    return next(newReq);
};
